import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { DataService } from "../data.service";
import { FormBuilder } from "@angular/forms";

export interface PeriodicElement {
  id: string;
  label: string;
  name: string;
  description: string;
  object: string;
  type: string;
  content: string;
}

@Component({
  selector: "app-globalaction",
  templateUrl: "./globalaction.component.html",
  styleUrls: ["./globalaction.component.scss"],
  // standalone: true,
  // imports: [MatTableModule]
})
export class GlobalactionComponent implements OnInit {
  metaglobalaction: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  metaactionName = "";
  metaactionId = "";
  metalayoutId = "";
  metaobjectName = "";
  metaobjectId = "";
  // Id = "";
  detailForm = this.fb.group({
    metaobjectid: "",
    metaobjectname: "",
    id: "",
    targetobject: "",
    targetobjectid: "",
    objectid: "",
    labelname: "",
    name: "",
    buttontype: "",
    actiontype: "",
    content: "",
    parentobjectid: "",
    parentobjectname: "",
    description: "",
    metalayoutid: "",
  });
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private dataService: DataService,
    private _router: Router
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.metaactionName = this.route.snapshot.params.name;
      this.metaactionId = this.route.snapshot.params.id;
      this.metaobjectName = this.route.snapshot.params.object;
      this.metaobjectId = this.route.snapshot.params.objectid;
      this.metalayoutId = this.route.snapshot.params.metalayoutid;

      // console.log(this.metaobjectName);
    });

    // console.log(this.metaactionName);

    this.getMetaGlobalAction();
  }
  displayedColumns: string[] = [
    "id",
    "label",
    "name",
    "object",
    "type",
    "modifiedby",
    "modifieddate",
    "content",
  ];
  dataSource = "";

  newAction() {
    this.router.navigateByUrl("home/globalaction/newaction/new");
  }

  getMetaGlobalAction() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
    };

    console.log(postOption);
    this.isLoading = true;
    this.dataService.getMetaGlobalAction(postOption).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.metaglobalaction = res.data.MetaGlobalAction;
          console.log("Doneeee****", this.metaglobalaction);

          if (this.metaglobalaction != null) {
            this.dataSource = this.metaglobalaction.map((item) => ({
              id: item.id,
              label: item.labelname,
              name: item.name,
              description: item.description,
              object: item.targetobject,
              objectid: item.targetobjectid,
              type: item.actiontype,
              content: item.content,
              metalayoutid: item.metalayoutid,
              modifiedby: item.modifiedby,
              modifieddate: item.modifieddate,
              // iseditDisabled: true,

            }));
          }

          this.isLoading = false;
        } else {
          console.log("Error while saving");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  delete(id: number, objectid: any, metalayoutid: any) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );
    const confirmDelete = window.confirm("Are you sure you want to delete?");
    if (!confirmDelete) {
      return;
    }

    this.isLoading = true;
    this.dataService
      .deleteMetaglobalaction(
        organizationid,
        domain,
        subdomain,
        id,
        objectid,
        metalayoutid
      )
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res.success == 1) {
            // alert("Are you sure?")
            // this.router.navigate(['home/globalaction'])
            window.location.reload();

            this.isLoading = false;
          } else {
            console.log("error in delete");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
        }
      );
  }
}
